module.exports = __webpack_public_path__ + "img/UT logo blue.b9abec47.jpg";